import React from 'react';
import { useState,useEffect } from "react";
import Swal from "sweetalert2";
import {Row,Col,Button} from "reactstrap";
import axios from "axios";
import Sidebar from '../../Sidebar';
import { useNavigate } from 'react-router';
import { BiSave } from "react-icons/bi";
import { IoIosEye } from "react-icons/io";
import { TiCancel } from "react-icons/ti";
import { AiOutlineHome } from "react-icons/ai";
import { useCookies } from 'react-cookie';
import { Link } from 'react-router-dom';
import Select from 'react-select';
import '../../button.css';
import {displayErrorToast,displayError} from '../../helpers';
import ErrorToast from '../../ErrorToast';
import FloatingControls from '../../components/FloatingControls';
import LoadingOverlay from '../../components/LoadingOverlay';
import { createProducts, getAllProducts } from "../../services/ProductServices";
import { getAllGroups } from "../../services/GroupFormServices";
import { getAllTax } from "../../services/TaxServices";
import RemarksStatusLine from '../../components/RemarksStatusLine';
import { getAllUnits } from "../../services/UnitServices";
import PremiumPageHeader from '../../components/PremiumPageHeader';

function Product() {
    const [cookies] = useCookies(['myToken']);
    const [inputs, setInputs] = useState({
     
        category_id :'',
        name : '',
        unit_id : '',
        quantity : 1,
        vendor_part_code : '',
        is_gst_applicable :"true",
        tax_id : '',
        hsn_sac_code : '',
        hsn_sac_description :'',
        prod_gst_type :"Goods",
        user_remarks :'',
        is_batch_report_connected :"false",
        status :"true"
   
    });
    
    const [error, setError] = useState({});
    const [isSubmitting, setIsSubmitting] = useState(false);
    const navigate = useNavigate();
    const [groups, setGroups] = React.useState([]);
    const [selectedUnit, setSelectedUnit] = useState(null);
    const [units, setUnits] = React.useState([]);
    const [group_id, setGroupId] = React.useState([]);
    const [taxes, setTaxes] = React.useState([]);
    const [inProgress, setInProgress] = useState(false);

    const onUnitSelect = (selected) => {
        setSelectedUnit(selected);
        setInputs(values => ({...values,['unit_id']:selected.value}))

    };

useEffect( () => {
    getAllGroups(cookies)
    .then(response => {
 const group =response.accounts_grouping_list.filter(obj => obj.entity_name == 'PRODUCT' )
        const a =[]
                        for(var i=0; i<response.accounts_grouping_list.length; i++) 
                        {
                            if((response.accounts_grouping_list[i].parent_id)=== (group[0].id))
                            {
                                a.push(response.accounts_grouping_list[i]);
                            }
                        }
                      
                        setGroups(a);
     

    });
 
  }, []);
  useEffect( () => {
    getAllTax(cookies)
    .then(response => {
  
        const tax_value=[]
                        for(var j=0; j<response.tax_list.length; j++) 
                        {
                            if(response.tax_list[j].status)
                            {
                                tax_value.push(response.tax_list[j]);
                              
                            }
                        }
                        setTaxes(tax_value);
                        console.log(JSON.stringify(tax_value)+"BBB")
     

    });
 
  }, []);

  useEffect( () => {
    getAllUnits(cookies)
    .then(response => {
 
        const unit_value=[]
                        for(var j=0; j<response.unit_list.length; j++) 
                        {
                            if(response.unit_list[j].status)
                            {
                                unit_value.push(response.unit_list[j]);
                              
                            }
                        }
                        setUnits(unit_value);
                        console.log(JSON.stringify(unit_value)+"BBB")
     

    });
 
  }, []);

  React.useEffect(() => {
    getAllUnits(cookies)
    .then (
        unitList => {
            
            const units = unitList.unit_list.map(
                unit => {
                    return { value: unit.id, label: unit.name }
                }
            );
            // Sort the units alphabetically based on the 'label' property
            units.sort((a, b) => a.label.localeCompare(b.label));

            setUnits(units);
        }
    )
}, []);
  
  const handleChangeTaxApplicable = (event) =>{
    const name = event.target.name;
    const value = event.target.value;
    if(value === 'false'){
       
        const selected_prod = taxes.filter(obj => obj.name == 'NO TAX')
        console.log(JSON.stringify(selected_prod)+"selected prod")
                          
        setInputs(values => ({...values, ['tax_id']: selected_prod[0].id}))
       document.getElementById('tax_id').disabled = true;
       document.getElementById('tax_id').required = false;
       document.getElementById('tax_id').className = document.getElementById('tax_id').className.replace('mandatory-form-control',''); 
    }
    else
    {
        document.getElementById('tax_id').disabled = false;
        document.getElementById('tax_id').required = true;
        document.getElementById('tax_id').className += ' mandatory-form-control'; 
    }
    setInputs(values => ({...values, [name]: event.target.value}))
}
    
    const handleChange = (event) => {
        const name = event.target.name;
        const value = event.target.value;

        if(name === 'name')   //Product must not be empty if it is already exist u can create new product name
        {
            if(!value.trim())
            {
                // setError(values => ({...values, [name]: "Product Name must not be empty..."}))
                setIsSubmitting(false); 
            }
            else{
                      
                setError(values => ({...values, [name]: ""}))
                setIsSubmitting(true); 
              }
         
        }
        else if(name === 'quantity')
        {
            if(value.trim())
            {
                if(!/^[0-9]*$/.test(value.trim()))
                {
                setError(values => ({...values, [name]: "Positive Numbers only allowed..."}))
                setIsSubmitting(false);
             
                }
                else
                {
                setError(values => ({...values, [name]: ''}))
                setIsSubmitting(true);
            
                }
            }
            else
            {
                setError(values => ({...values, [name]: ''}))
                setIsSubmitting(true);
            }
        }

        setInputs(values => ({...values, [name]: event.target.value}))
    }
  const handleSubmit=(event)=> {
    event.preventDefault();

    if ((Object.values(error).every(x => !x)) && isSubmitting) //If all the required fields are field u can select the save button then choose the option yes or no
    {
        Swal.fire({title: 'Do you want to save?',  
          showCancelButton: true,  
          confirmButtonText: `Yes`,  
          cancelButtonText: `No`,
          }).then((result) => {  
            if (result.isConfirmed) { 
                console.log(JSON.stringify(inputs)+"inputsubmit")
                createProducts(cookies, {
                    category_id:inputs.category_id,
                    name: inputs.name,
                    unit_id:inputs.unit_id,
                    quantity:inputs.quantity,
                    vendor_part_code:inputs.vendor_part_code,
                    is_gst_applicable:inputs.is_gst_applicable,
                    tax_id: inputs.tax_id,
                    hsn_sac_code:inputs.hsn_sac_code,
                    hsn_sac_description:inputs.hsn_sac_description,
                    prod_gst_type: inputs.prod_gst_type,
                    user_remarks: inputs.user_remarks,
                    is_batch_report_connected:inputs.is_batch_report_connected,
                    status:inputs.status
               })
               //console.log(createAccountMaster)
              .then(response => {
                  Swal.fire("Saved!", "", "success");
                  view();
              }).catch((error) => {
                  console.log(error.response.data);
                  displayError(error.response.data,"Saved Failed");
              });
              
            } 
            else if (result.isDismissed) 
            {    
              Swal.fire('Not saved', '', 'info')  
            }
          });
    }

  }

        const Reload = () => {
          window.location.reload();
        }      
        const view = () => {
          navigate('/ProductTable')
        }  
        const Back = () => {
          navigate('/Home')
        }
        const Cancel = () => {
          
            setInputs({
                category_id :'',
                name : '',
                unit_id : '',
                quantity : 1,
                vendor_part_code : '',
                is_gst_applicable :"",
                tax_id : '',
                hsn_sac_code : '',
                hsn_sac_description :'',
                prod_gst_type :"Goods",
                user_remarks :'',
                is_batch_report_connected :"false",
                status :""
           
            });
        }
    return (
    <>
     <div id="outer-container"  className="App" > 
        <Sidebar pageWrapId={'page-wrap'} outerContainerId={'outer-container'} />
        <ErrorToast/>
        <LoadingOverlay inProgress={inProgress}/>
        <div id="page-wrap">
        <form onSubmit={handleSubmit}> 
          <div className="premium-page-header-wrap">
              <PremiumPageHeader
                module="ADMIN"
                title="Product Registration"
                subtitle="Create product master records for sales and purchase."
                modeLabel="ADD MODE"
              />
            </div>
         
            <FloatingControls tableLink="/ProductTable" onCancel={Cancel} enableCancel={true}/>
            <div className="container"> 
                <Row className="product-form-pair"> 
                <Col xl={6} lg={12} md={12}>   
                <div className="form-row table-bordered shadow p-2 my-2 border-secondary p-2 mb-3 bg-blue form-control-panel product-match-panel" >
                <h5 className='col-sm-11'><b>Product Details</b></h5><br/><br/>
                            <label htmlFor="category_id" className="form-group col-sm-4 text-right">Group Name </label>
                            <select  id="category_id" required name="category_id" className="browser-default custom-select form-control col-sm-7 mandatory-form-control" onChange={handleChange} value={inputs.category_id || ""}>
                                <option value="">Select Code</option>
                                {groups.map((item) => (
                                    <option key={item.id} value={item.id}>
                                    {item.entity_name}
                                    </option>
                                ))}
                            </select><br/><br/>
                   
                            <label htmlFor="name" className="form-group col-sm-4 text-right">Product Name </label>
                            <input type="text" id="name"  name="name" placeholder="Name Of The Product" className="form-control  col-sm-7 mandatory-form-control"   required onChange={handleChange} value={inputs.name || ""}/><br/><br/>
                            {error.name && (<><strong className="form-group col-sm-12 text-center text-danger" >{error.name}</strong><br/></>)}
                            {/* <label htmlFor="unit_id" className="form-group col-sm-4 text-right">Unit </label>
                            <select  id="unit_id" required name='unit_id' className="form-control col-sm-7 browser-default custom-select mandatory-form-control" onChange={handleChange} value={inputs.unit_id || ""}>
                                <option value="">Select Unit</option>
                                {units.map((item) => (
                                    <option key={item.id} value={item.id}>
                                    {item.name}
                                    </option>
                                ))}
</select> */}

               <label htmlFor="unit_id" className="form-group col-sm-4 text-right">Unit</label>
                                <div style={{width: '58%'}} >
                                  <Select
                                  id="unit_id"
                                    options={units}
                                    isMulti= {false}
                                    isSearchable={true}
                                    value={selectedUnit}
                                    onChange={onUnitSelect}
                                    className={"mandatory-form-control react-select-dropdown"}
                                   // placeholder="Please Select Unit"
                                  />
                                  </div>
                                <br/><br/>
                    
                            <label htmlFor="vendor_part_code" className="form-group col-sm-4 text-right">Vendor Part Code</label>
                            <input type="text"id="vendor_part_code" name="vendor_part_code" onChange={handleChange} value={inputs.vendor_part_code || ""}placeholder="Enter Code Number"    className="form-control  col-sm-7"/><br/><br/>
                      
                            <label htmlFor="quantity" className="form-group col-sm-4 text-right">Qty </label>
                            <input type="number" min="0" name="quantity" id="quantity" onChange={handleChange} value={inputs.quantity || ""}placeholder="Input Numbers"  required  className="form-control  col-sm-7 mandatory-form-control" /><br/><br/>
                            {error.quantity && (<><strong className="form-group col-sm-12 text-center text-danger" >{error.quantity}</strong><br/></>)}
                      
                            <label htmlFor="is_batch_report_connected" className="form-group col-sm-4 text-right"> Is Connect with BR?</label>
                            <select id="is_batch_report_connected" name="is_batch_report_connected" onChange={handleChange} value={inputs.is_batch_report_connected || ""}required className="form-control col-sm-7 browser-default custom-select mandatory-form-control">
                                <option value="false">No</option>
                                <option value="true">Yes</option>
                            </select><br/><br/>
                            </div>
                </Col>
                    <Col xl={6} lg={12} md={12}>   
                   
                    <div className="form-row table-bordered shadow p-2 my-2 border-secondary p-2 mb-3 bg-blue form-control-panel product-match-panel" >
                    <h5 className='col-sm-11'><b>GST Details</b></h5><br/><br/>
                            <label htmlFor="is_gst_applicable" className="form-group col-sm-4 text-right">Is GST Applicable? </label>
                            <select id="is_gst_applicable" onChange={handleChangeTaxApplicable} value={inputs.is_gst_applicable || "true"} name="is_gst_applicable" required className="form-control col-sm-7 browser-default custom-select mandatory-form-control">
                            {/* <option value=''>Select GST</option> */}
                                <option value="true" >Yes</option>
                                <option value="false" >No</option>
                            </select><br/><br/>

                    
                            <label htmlFor="tax_id" className="form-group col-sm-4 text-right">Tax Code </label>
                            <select  id="tax_id" onChange={handleChange} value={inputs.tax_id || ""}  name='tax_id' className="form-control col-sm-7 browser-default custom-select" disabled={false}>
                                <option value='select tax code'>Select Tax Code</option>
                                {taxes.map((item) => (
                                    <option key={item.id} value={item.id}>
                                    {item.name}
                                    </option>
                                ))}
                            </select><br/><br/>
                           
                            
                            <label htmlFor="prod_gst_type" className="form-group col-sm-4 text-right">GST Type</label>
                            <select name="prod_gst_type" id="prod_gst_type" onChange={handleChange} value={inputs.prod_gst_type || ""}className="form-control col-sm-7 browser-default custom-select">
                                <option value="Goods" >Goods</option>
                                <option value="Services">Services</option>
                            </select><br/>
                            <label htmlFor="hsn_sac_code" className="form-group col-sm-4 text-right">HSN / SAC Code</label>
                            <input type="text" id="hsn_sac_code" name="hsn_sac_code" onChange={handleChange} value={inputs.hsn_sac_code || ""}className="form-control  col-sm-7" placeholder="Enter Number" /><br/><br/>
                      
                            <label htmlFor="hsn_sac_description" className="form-group col-sm-4 text-right">HSN/SAC Description</label>
                            <input type="text" id="hsn_sac_description"name="hsn_sac_description" onChange={handleChange} value={inputs.hsn_sac_description || ""}className="form-control  col-sm-7" placeholder="Enter Some Text.." /><br/>
                        </div>
                        
                    
                    </Col>
                </Row>
                <Row>
                <Col xl={12} lg={12} md={12}>
                            <div className="form-row table-bordered shadow p-2 my-2 border-secondary p-2 mb-3 product-status-line" style={{backgroundColor:"RGB(188,232,253)",borderRadius:"10px",fontWeight:"bold"}}>
                            <RemarksStatusLine remarks={inputs.user_remarks} status={inputs.status} onChange={handleChange} />
                        </div>
                </Col>
                </Row>             
            </div>
                              <div className="footer text-center">
                              <Button  type="submit"  style={{width:"80px",fontWeight:"bold",backgroundColor:"RGB(58,29,238,0.8)"}} className="btn btn-twitter">Save</Button> &nbsp;&nbsp;
                    <Button type="button"  style={{width:"80px",fontWeight:"bold",backgroundColor:"RGB(58,29,238,0.8)"}}className="btn btn-twitter" onClick={Cancel}>Reset</Button> &nbsp;&nbsp;
                    <Button   type="button"style={{width:"80px",fontWeight:"bold",backgroundColor:"RGB(58,29,238,0.8)"}} className="btn btn-twitter"onClick={view}>View</Button>&nbsp;&nbsp;
                    <Button  type="button"style={{width:"80px",fontWeight:"bold",backgroundColor:"RGB(58,29,238,0.8)"}} className="btn btn-twitter"onClick={Back}>Home</Button>
                              </div>
        </form>
        </div>
    </div>
         </>
    );
  }
  export default Product;
  